import { sanitizeNumberInputValue } from './sanitizeNumberInputValue';

export function sanitizeCurrencyInputValue(value: string): string {
  return sanitizeNumberInputValue(value, 2);
}
